/* Textarea: multi-line text, auto-growing up to `maxRows`. Joins a surrounding <Field>. */
import { forwardRef, type TextareaHTMLAttributes } from 'react'
import { cn } from '@/lib/cn'
import { controlClasses } from './control'
import { useFieldProps } from './Field'

export const Textarea = forwardRef<
  HTMLTextAreaElement,
  TextareaHTMLAttributes<HTMLTextAreaElement> & { mono?: boolean }
>(function Textarea({ className, mono, rows = 4, ...props }, ref) {
  const field = useFieldProps(props)
  return (
    <textarea
      ref={ref}
      rows={rows}
      {...props}
      {...field}
      dir={mono ? 'ltr' : props.dir}
      className={cn(
        controlClasses,
        '[field-sizing:content] min-h-24 resize-y px-3 py-2.5 leading-6',
        mono && 'font-mono text-13',
        className,
      )}
    />
  )
})
